import {ITableColumn} from '../../../types';
import {ReactNode} from 'react';
import { Account } from "../accounts/types";


export type Application = {
    id: string,
    name?: string,
    description?: string,
    url?: string,
    logoUrl?: string
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    updatedByUsername?: string
    updatedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export type AccountApplicationDimension = { name: string, value: string }

export enum AccountApplicationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export type AccountApplication = {
    id: string,
    accountId: string,
    account: Account,
    applicationId: string,
    application: Application,
    accountApplicationStatus: AccountApplicationStatus,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    managedByUsername?: string
    managedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


// FNP-899: mirrors console-api's CreateAccountApplicationInput. A create carries
// none of the server-assigned fields (id, account, application), so callers used to
// cast to AccountApplication to satisfy the compiler — and the cast silently hid a
// MISSING accountApplicationStatus. A row born without a status is not a seat
// (console-api emit-seat-occupancy.ts), so it opens no SeatOccupancy interval and
// the seat is never billed. Typing the create explicitly makes that omission a
// compile error instead of a runtime under-bill.
export type CreateAccountApplicationInput = {
    accountId: string,
    applicationId: string,
    accountApplicationStatus: AccountApplicationStatus,
}

export interface IAccountApplicationTableColumn extends ITableColumn {
    render?: (item: AccountApplication) => ReactNode;
}

export type ListAccountApplications = {
    listAccountApplications: { items: AccountApplication[], nextToken?: string | null }
}

export type GetAccountApplication = {
    getAccountApplication: AccountApplication
}

export type CreateAccountApplication = {
    createAccountApplication: AccountApplication
}

export type UpdateAccountApplication = {
    updateAccountApplication: AccountApplication
}

export type DeleteAccountApplication = {
    deleteAccountApplication: string
}
